import { generator } from  '../event-listener';

export const OnMount = generator('onMount');
export const OnRender = generator('onRender');
export const OnUnmount = generator('onUnmount');
